import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from '../../services/report.service';
import { ColumnDefinition, Filter } from '../../models/Report';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.css']
})
export class ReportDetailComponent implements OnInit {

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  columns : ColumnDefinition[] = [];
  reportTitle : string;
  displayTable: boolean = false;
  filters : Array<Filter>;
  dtOptions: DataTables.Settings = {};
  showFilter: boolean = false;
  showAppliedFilter: boolean = false;

  constructor(private route: ActivatedRoute, private reportService: ReportService) { }

 
  ngOnInit() {
    
    this.route.params.subscribe(params => {
      let reportId = params['id'];

      this.reportService.getTabularReport(reportId).subscribe(resp => {
        this.reportTitle = resp.report.title;
        this.filters = resp.filters;
        this.columns = resp.report.columnDefinitions.sort((a, b) => a.columnIndex - b.columnIndex);
        this.dtOptions = this.reportService.getDataTableOptions(reportId, this.columns, this.filters);
        this.displayTable = true;
      });
      
    }); 
  }

  applyFilter(){
    let count = 0;
    this.filters.forEach(filter => {
      if(filter.type == 'Date' && filter.objectValue != null){
        filter.displayValue = filter.objectValue.format('MMMM Do YYYY');
        filter.value = filter.objectValue.toLocaleDateString("en-US");
        
      } else if(filter.type == 'DateRange' && filter.objectValue != null && filter.objectValue[0] != null && filter.objectValue[1] != null){
          filter.displayValue = filter.objectValue[0].toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: '2-digit' }) + ',' + filter.objectValue[1].toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: '2-digit' });
          let start = filter.objectValue[0].toLocaleDateString("en-US");
          let end = filter.objectValue[1].toLocaleDateString("en-US");
          filter.value = start + ',' + end;
      } else if(filter.type == 'Integer' && filter.objectValue != null){
        filter.value = filter.objectValue
        if(filter.data){
          let val = filter.data.find(d => d.id == filter.objectValue);
          if(val) filter.displayValue = val.name;
        } else {
          filter.displayValue = filter.objectValue
        }

      } else {
        filter.displayValue = filter.objectValue;
        filter.value = filter.objectValue
      }

      if(filter.value != null) count++;
    });

    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
    this.showFilter = false;
    this.showAppliedFilter = count > 0;
  }

  removeFilter(){
    this.filters.forEach(filter => {
      filter.value = null;
      filter.objectValue = null;
    });
  }
}
